import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./css/Reports.scss";

// Components

import TitleBox from "../components/TitleBox";
import Footer from "../components/Footer";
import Accordion from "../components/Accordion";

// Icons

import { Download } from "react-feather";

// Files

import file_1 from "../assets/pdf/Amended Articles of Incorporation.pdf";
import file_2 from "../assets/pdf/Getwell Ammended By Laws.pdf";
import file_3 from "../assets/pdf/2016 GENERAL INFORMATION SHEET (GIS).pdf";
import file_4 from "../assets/pdf/2017 GENERAL INFORMATION SHEET (GIS).pdf";
import file_5 from "../assets/pdf/2018 GENERAL INFORMATION SHEET (GIS).pdf";
import file_6 from "../assets/pdf/2019 GENERAL INFORMATION SHEET (GIS).pdf";
import file_7 from "../assets/pdf/2020 GENERAL INFORMATION SHEET (GIS).pdf";
import file_8 from "../assets/pdf/General Information Sheet (GIS to 2021).pdf";
import file_9 from "../assets/pdf/Directors' Certificate to Mr Johnny G De Leon (Cubao Branch).pdf";
import file_10 from "../assets/pdf/Directors' Certificate to Mr Rolando M Berin (GenSan branch).pdf";
import file_11 from "../assets/pdf/Director's Certificate to Ms Annaliza H Lumanglas ( Batangas Branch ).pdf";
import file_12 from "../assets/pdf/Directors' Certificate to Ms Annaliza H Lumanglas ( Bauan Branch ).pdf";
import file_13 from "../assets/pdf/Directors' Certificate to Ms Divinia A Segui ( Calamba Branch ).pdf";
import file_14 from "../assets/pdf/Directors' Certificate to Ms Divinia A Segui ( Lipa Branch ).pdf";
import file_15 from "../assets/pdf/Director's Certificate to Ms Nelsa C Arrojado (Cebu branch).pdf";
import file_16 from "../assets/pdf/Notice of Annual Shareholders Meeting (Dec 4, 2020).pdf";
import file_17 from "../assets/pdf/Minutes of Annual Stockholders Metting (December 4, 2020).pdf";
import file_18 from "../assets/pdf/GHSI Table of Attendance of Board of Directors.pdf";
import file_19 from "../assets/pdf/2020 Annual Corporate Governance Report (SCORE CARD).pdf";
import file_20 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting January 17, 2020.pdf";
import file_21 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting February 17, 2020.pdf";
import file_22 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting June 30, 2020.pdf";
import file_23 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Special Meeting July 20, 2020.pdf";
import file_24 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting September 04, 2020.pdf";
import file_25 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Special Meeting November 06, 2020.pdf";
import file_26 from "../assets/pdf/BOD Minutes of Meeting 2020/BOD Regular Meeting December 14, 2020.pdf";
import file_27 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 20 January 2021.pdf";
import file_28 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 22 January 2021.pdf";
import file_29 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 16 February 2021.pdf";
import file_30 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 16 March 2021.pdf";
import file_31 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 07 April 2021.pdf";
import file_32 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 13 April 2021.pdf";
import file_33 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 12 May 2021.pdf";
import file_34 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 26 May 2021.pdf";
import file_35 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Special Meeting 28 May 2021.pdf";
import file_36 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 17 June 2021.pdf";
import file_37 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 20 August 2021.pdf";
import file_38 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 02 September 2021.pdf";
import file_39 from "../assets/pdf/BOD Minutes of Meeting 2021/BOD Regular Meeting 10 November 2021.pdf";
import file_40 from "../assets/pdf/Notice of the ASM 2021/Notice of Annual Shareholder's Meeting 2021.pdf";
import file_41 from "../assets/pdf/Notice of the ASM 2021/Procedures for Participating in the Stockholdr's Meeting via remote communication or in absentia.pdf";
import file_42 from "../assets/pdf/Minutes of the ASM 2021/BOD Special Organizational Meeting 05 March 2021.pdf";
import file_43 from "../assets/pdf/Minutes of the ASM 2021/Minutes of the Annual Shareholder's Meeting 05 March 2021.pdf";
import file_44 from "../assets/pdf/2021 Annual Corporate Governance Report (ACGR) Scorecard.pdf";
import file_45 from "../assets/pdf/2020 Audited Financial Statement.pdf";
import file_46 from "../assets/pdf/2020-2021 Annual Financial Statement.pdf";

// update 06-21-23 -wac file 47 -58
import file_47 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 12 January 2022.pdf";
import file_48 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 16 February.pdf";
import file_49 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 16 March 2022.pdf";
import file_50 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Special Board Minutes 8 July 2022.pdf";
import file_51 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Special Board Minutes 20 July 2022.pdf";
import file_52 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 21 July 2022.pdf";
import file_53 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Special Board Minutes 24 August 2022.pdf";
import file_54 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 19 September 2023.pdf";
import file_55 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Regular Board Minutes 11 October 2022.pdf";
import file_56 from "../assets/pdf/BOD Minutes of Meeting 2022/GHSI Special Board Minutes 9 December.pdf";

import file_57 from "../assets/pdf/2022 Audited Financial Statement (GHSI).pdf";
import file_58 from "../assets/pdf/Notice of the ASM 2022/GHSI Notice ASM 22 March 2022.pdf";

import file_59 from "../assets/pdf/Notice of the ASM 2022/GHSI ANNUAL SHAREHOLDERS MINUTES OF MEETING APRIL 20,2022.pdf";
import file_60 from "../assets/pdf/1. AFS_Getwell Health SystemsInc_12312023 ending December 2023.pdf";
import file_61 from "../assets/pdf/GIS(GENERAL INFO. SHEET) 2022.pdf";
import file_62 from "../assets/pdf/GHSI Filed 2023 GIS.pdf";

import file_63 from "../assets/pdf/Notice of the ASM 2023/2023- GHSI Notice of Annual Stockholders Meeting.pdf"
import file_64 from "../assets/pdf/Minutes of the ASM 2023/2023-GHSI-Annual Stockholders Meeting Minutes.pdf"
import file_65 from "../assets/pdf/2024 GIS _ GHSI with SEC Acceptance.pdf"
import file_66 from "../assets/pdf/Notice of the ASM 2024/2024 - GHSI Notice of Annual Stockholders Meeting.pdf"
import file_67 from "../assets/pdf/Minutes of the ASM 2024/2024-GHSI Annual Stockholders Meeting Minutes.pdf"

import file_68 from "../assets/pdf/acgr_scorecards/ACGR SCORECARD for 2024.pdf"
import file_69 from "../assets/pdf/BOD Minutes of Meeting 2024/01.19.24 Minutes of the Special Meeting of the BOD.pdf"
import file_70 from "../assets/pdf/BOD Minutes of Meeting 2024/02.15.24 Minutes of the Special Meeting of the BOD.pdf"
import file_71 from "../assets/pdf/BOD Minutes of Meeting 2024/04.11.24 Minutes of the Regular Meeting.pdf"
import file_72 from "../assets/pdf/BOD Minutes of Meeting 2024/04.26.24 Minutes of the Special Meeting of the BOD.pdf"
import file_73 from "../assets/pdf/BOD Minutes of Meeting 2024/06.20.24 Minutes of the Meeting of the BOD.pdf"
import file_74 from "../assets/pdf/BOD Minutes of Meeting 2024/07.11.24 Minutes of the Special Meeting of the BOD.pdf"
import file_75 from "../assets/pdf/BOD Minutes of Meeting 2024/07.25.24 Minutes of the Regular Meeting of the BOD.pdf"
import file_76 from "../assets/pdf/BOD Minutes of Meeting 2024/08.16.2024 Minutes of the Special Meeting.pdf"
import file_77 from "../assets/pdf/BOD Minutes of Meeting 2024/08.28.24 Minutes of the Meeting of the BOD.pdf"
import file_78 from "../assets/pdf/BOD Minutes of Meeting 2024/10.17.24 Minutes of the Regular Meeting of the BOD.pdf"
import file_79 from "../assets/pdf/BOD Minutes of Meeting 2024/11.15.24 Minutes of the Regular Meeting of the BOD.pdf"
import file_80 from "../assets/pdf/BOD Minutes of Meeting 2024/11.20.24 - Minutes of the Regular Meeting of the BOD.pdf"
import file_81 from "../assets/pdf/BOD Minutes of Meeting 2024/12.18.24 Minutes of the Regular Meeting of the BOD.pdf"

const IncorporationData = [
  {
    name: "Articles of Incorporation",
    file: file_1,
  },
];

const ByLawsData = [
  {
    name: "Amended By-Laws",
    file: file_2,
  },
];

const GISData = [
  {
    name: "General Information Sheet (GIS-2016)",
    file: file_3,
  },
  {
    name: "General Information Sheet (GIS-2017)",
    file: file_4,
  },
  {
    name: "General Information Sheet (GIS-2018)",
    file: file_5,
  },
  {
    name: "General Information Sheet (GIS-2019)",
    file: file_6,
  },
  {
    name: "General Information Sheet (GIS-2020)",
    file: file_7,
  },
  {
    name: "General Information Sheet (GIS-2021)",
    file: file_8,
  },
  {
    name: "General Information Sheet (GIS-2022)",
    file: file_61,
  },
  {
    name: "General Information Sheet (GIS-2023)",
    file: file_62,
  },
  {
    name: "General Information Sheet (GIS-2024)",
    file: file_65,
  }
];

const sortGISData = (a, b) => {
  const yearA = extractYear(a.name);
  const yearB = extractYear(b.name);

  return yearB - yearA;
};

const extractYear = (name) => {
  const yearMatch = name.match(/\d{4}/);
  return yearMatch ? parseInt(yearMatch[0]) : 0;
};

GISData.sort(sortGISData);

const BODMeeting_2020 = [
  {
    name: "BOD Regular Meeting January 17, 2020",
    file: file_20,
  },
  {
    name: "BOD Regular Meeting February 17, 2020",
    file: file_21,
  },
  {
    name: "BOD Regular Meeting June 30, 2020",
    file: file_22,
  },
  {
    name: "BOD Special Meeting July 20, 2020",
    file: file_23,
  },
  {
    name: "BOD Regular Meeting September 04, 2020",
    file: file_24,
  },
  {
    name: "BOD Special Meeting November 06, 2020",
    file: file_25,
  },
  {
    name: "BOD Regular Meeting December 14, 2020",
    file: file_26,
  },
];

const BODMeeting_2021 = [
  {
    name: "BOD Special Meeting 20 January 2021",
    file: file_27,
  },
  {
    name: "BOD Special Meeting 22 January 2021",
    file: file_28,
  },
  {
    name: "BOD Regular Meeting 16 February 2021",
    file: file_29,
  },
  {
    name: "BOD Special Meeting 16 March 2021",
    file: file_30,
  },
  {
    name: "BOD Special Meeting 07 April 2021",
    file: file_31,
  },
  {
    name: "BOD Special Meeting 13 April 2021.pdf",
    file: file_32,
  },
  {
    name: "BOD Regular Meeting 12 May 2021.pdf",
    file: file_33,
  },
  {
    name: "BOD Regular Meeting 26 May 2021.pdf",
    file: file_34,
  },
  {
    name: "BOD Special Meeting 28 May 2021.pdf",
    file: file_35,
  },
  {
    name: "BOD Regular Meeting 17 June 2021.pdf",
    file: file_36,
  },
  {
    name: "BOD Regular Meeting 20 August 2021.pdf",
    file: file_37,
  },
  {
    name: "BOD Regular Meeting 02 September 2021.pdf",
    file: file_38,
  },
  {
    name: "BOD Regular Meeting 10 November 2021.pdf",
    file: file_39,
  },
];

const BODMeeting_2022 = [
  {
    name: "GHSI Regular Board Minutes 12 January 2022.pdf",
    file: file_47,
  },

  {
    name: "GHSI Regular Board Minutes 16 February.pdf",
    file: file_48,
  },
  {
    name: "GHSI Regular Board Minutes 16 March 2022.pdf",
    file: file_49,
  },

  {
    name: "GHSI Special Board Minutes 8 July 2022.pdf",
    file: file_50,
  },
  {
    name: "GHSI Special Board Minutes 20 July 2022.pdf",
    file: file_51,
  },
  {
    name: "GHSI Regular Board Minutes 21 July 2022.pdf",
    file: file_52,
  },
  {
    name: "GHSI Special Board Minutes 24 August 2022.pdf",
    file: file_53,
  },
  {
    name: "GHSI Regular Board Minutes 19 September 2023.pdf",
    file: file_54,
  },
  {
    name: "GHSI Regular Board Minutes 11 October 2022.pdf",
    file: file_55,
  },
  {
    name: "GHSI Special Board Minutes 9 December.pdf",
    file: file_56,
  },
];

const BODMeeting_2024 = [
  {
    name: "01.19.24 Minutes of the Special Meeting of the BOD.pdf",
    file: file_69,
  },
  {
    name: "02.15.24 Minutes of the Special Meeting of the BOD.pdf",
    file: file_70,
  },
  {
    name: "04.11.24 Minutes of the Regular Meeting.pdf",
    file: file_71
  },
  {
    name: "04.26.24 Minutes of the Special Meeting of the BOD.pdf",
    file: file_72
  },
  {
    name: "06.20.24 Minutes of the Meeting of the BOD.pdf",
    file: file_73
  },
  {
    name: "07.11.24 Minutes of the Special Meeting of the BOD.pdf",
    file: file_74
  },
  {
    name: "07.25.24 Minutes of the Regular Meeting of the BOD.pdf",
    file: file_75
  },
  {
    name: "08.16.2024 Minutes of the Special Meeting.pdf",
    file: file_76
  },
  {
    name: "08.28.24 Minutes of the Meeting of the BOD.pdf",
    file: file_77
  },
  {
    name: "10.17.24 Minutes of the Regular Meeting of the BOD.pdf",
    file: file_78
  },
  {
    name: "11.15.24 Minutes of the Regular Meeting of the BOD.pdf",
    file: file_79
  },
  {
    name: "11.20.24 - Minutes of the Regular Meeting of the BOD.pdf",
    file: file_80
  },
  {
    name: "12.18.24 Minutes of the Regular Meeting of the BOD.pdf",
    file: file_81
  }
]

const StockHoldersData = [
  {
    name: "Directors' Certificate to Mr. Johnny G. De Leon (Cubao Branch)",
    file: file_9,
    content: "",
  },
  {
    name: "Directors' Certificate to Mr. Rolando M. Berin (GenSan branch)",
    file: file_10,
    content: "",
  },
  {
    name: "Director's Certificate to Ms. Annaliza H. Lumanglas (Batangas Branch)",
    file: file_11,
    content: "",
  },
  {
    name: "Directors' Certificate to Ms. Annaliza H. Lumanglas (Bauan Branch)",
    file: file_12,
    content: "",
  },
  {
    name: "Directors' Certificate to Ms. Divinia A. Segui (Calamba Branch)",
    file: file_13,
    content: "",
  },
  {
    name: "Directors' Certificate to Ms. Divinia A. Segui (Lipa Branch)",
    file: file_14,
    content: "",
  },
  {
    name: "Director's Certificate to Ms. Nelsa C. Arrojado (Cebu branch)",
    file: file_15,
    content: "",
  },
  {
    name: "2020 Board of Directors Minutes of Meeting",
    file: "",
    content: BODMeeting_2020,
  },
  {
    name: "2021 Board of Directors Minutes of Meeting",
    file: "",
    content: BODMeeting_2021,
  },
  {
    name: "2022 Board of Directors Minutes of Meeting",
    file: "",
    content: BODMeeting_2022,
  },
  {
    name: "2024 Board of Directors Minutes of Meeting",
    file: "",
    content: BODMeeting_2024
  }
];

const extractYearFromStockHolderData = (itemName) => {
  const regex = /\b\d{4}\b/;
  const match = itemName.match(regex);
  return match ? parseInt(match[0]) : 0;
};

StockHoldersData.sort((a, b) => {
  const yearA = extractYearFromStockHolderData(a.name);
  const yearB = extractYearFromStockHolderData(b.name);
  return yearB - yearA;
});

const ASMDataNotice = [
  {
    name: "Notice of Annual Shareholder's Meeting 2021",
    file: file_40,
  },
  {
    name: "Procedures for Participating in the Stockholder's Meeting via remote communication or in absentia",
    file: file_41,
  },
  {
    name: "Notice of Annual Shareholder's Meeting 2022",
    file: file_58,
  },
  {
    name: "Notice of Annual Shareholder's Meeting 2023",
    file: file_63,
  },
];

const ASMData2024 = [
  {
    name: "Notice of Annual Shareholder's Meeting 2024",
    file: file_66,
  },
  {
    name: "2024 Minutes of Meeting of the Annual Shareholder's Meeting",
    file: file_67,
    content: "",
  },
]

const ASMMinutesData = [
  {
    name: "BOD Special Organizational Meeting 05 March 2021",
    file: file_42,
  },
  {
    name: "Minutes of the Annual Shareholder's Meeting 05 March 2021",
    file: file_43,
  },
  {
    name: "Minutes of the Annual Shareholder's Meeting 30 March 2023",
    file: file_64,
  },
];

const ASMMinutesData2024 = [
  {
    name: "Minutes of the Annual Shareholder's Meeting 26 April 2024",
    file: file_67,
  },
]

const ASMData = [
  {
    name: "2020 Notice of Annual Shareholders Meeting ",
    file: file_16,
    content: "",
  },
  {
    name: "2020 Minutes of Annual Stockholders Meeting ",
    file: file_17,
    content: "",
  },
  {
    name: "GHSI Table of Attendance of Board of Directors",
    file: file_18,
    content: "",
  },
  {
    name: "2022 Minutes of the Annual Shareholder's Meeting Of Getwell Health Systems, Inc.",
    file: file_59,
    content: "",
  },
  {
    name: "2021 Notice of Annual Shareholder's Meeting",
    file: "",
    content: ASMDataNotice,
  },
  {
    name: "2021 Minutes of Meeting of the Annual Shareholder's Meeting",
    file: "",
    content: ASMMinutesData,
  },
  {
    name: "2022 Notice of Annual Shareholder's Meeting",
    file: "",
    content: ASMDataNotice,
  },
  {
    name: "2024 Annual Shareholder's Meeting",
    file: "",
    content: ASMData2024
  }
];

const sortASMData = (a, b) => {
  const regex = /^\d{4}/;
  const yearA = a.name.match(regex);
  const yearB = b.name.match(regex);

  if (yearA && yearB) {
    return parseInt(yearB[0]) - parseInt(yearA[0]);
  } else if (yearA) {
    return -1;
  } else if (yearB) {
    return 1;
  } else {
    return a.localeCompare(b);
  }
};
ASMData.sort(sortASMData);

const ACGRData = [
  {
    name: "2020 Annual Corporate Governance Report (ACGR) Scorecard",
    file: file_19,
  },
  {
    name: "2021 Annual Corporate Governance Report (ACGR) Scorecard",
    file: file_44,
  },
  {
    name: "2024 Annual Corporate Governance Report (ACGR) Scorecard",
    file: file_68
  }
];

const extractYearFromACGRData = (itemName) => {
  const regex = /\b\d{4}\b/; // Match any 4-digit number
  const match = itemName.match(regex);
  return match ? parseInt(match[0]) : 0;
};

ACGRData.sort((a, b) => {
  const yearA = extractYearFromACGRData(a.name);
  const yearB = extractYearFromACGRData(b.name);
  return yearB - yearA;
});

const AFSData = [
  {
    name: "Financial Reports for the year ended December 31, 2019 and 2020",
    file: file_45,
  },
  {
    name: "Financial Reports for the year ended December 31, 2020 and 2021",
    file: file_46,
  },
  {
    name: "Financial Reports for the year ended December 31, 2021 and 2022",
    file: file_57,
  },
  {
    name: "Financial Reports for the year ended December 31, 2022 and 2023",
    file: file_60
  }
];

const extractDate = (fileName) => {
  const regex = /(\d{4})/;
  const match = fileName.match(regex);
  if (match && match.length >= 1) {
    return parseInt(match[0]);
  }
  return 0;
};

AFSData.sort((a, b) => {
  const dateA = extractDate(a.name);
  const dateB = extractDate(b.name);
  return dateB - dateA;
});

const Reports = () => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  return (
    <div
      className="reports-container"
      style={{
        height: height - 75,
        width: width,
      }}
    >
      <TitleBox title={"Reports"} />
      <div className="reports-selection">
        <div className="inner-container">
          <h1 className="title" id="incorporation">
            Incorporation
          </h1>
          <div id="containerReports">
            {IncorporationData.map((fileDetails, index) => {
              return (
                <div className="row" key={index}>
                  <div className="row-title">
                    <div className="link">{fileDetails.name}</div>
                  </div>
                  <Link to={fileDetails.file} target="_blank" download>
                    <div className="row-text">
                      <Download />
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>

          <h1 className="title" id="by-laws">
            By Laws
          </h1>
          <div id="containerReports">
            {ByLawsData.map((fileDetails, index) => {
              return (
                <div className="row" key={index}>
                  <div className="row-title">
                    <div className="link">{fileDetails.name}</div>
                  </div>
                  <Link to={fileDetails.file} target="_blank" download>
                    <div className="row-text">
                      <Download />
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>

          <h1 className="title" id="afs">
            AFS
          </h1>
          <div id="containerReports">
            {AFSData.map((fileDetails, index) => {
              return (
                <div className="row" key={index}>
                  <div className="row-title">
                    <div className="link">{fileDetails.name}</div>
                  </div>
                  <Link to={fileDetails.file} target="_blank" download>
                    <div className="row-text">
                      <Download />
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
          <h1 className="title" id="gis">
            GIS
          </h1>
          <div id="containerReports">
            {GISData.map((fileDetails, index) => {
              return (
                <div className="row" key={index}>
                  <div className="row-title">
                    <div className="link">{fileDetails.name}</div>
                  </div>
                  <Link to={fileDetails.file} target="_blank" download>
                    <div className="row-text">
                      <Download />
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>

          <h1 className="title" id="stockholders-meeting">
            Stockholder Meeting Minutes
          </h1>
          <div id="containerReports">
            {StockHoldersData.map((fileDetails, index) => {
              if (fileDetails.content) {
                return (
                  <React.Fragment key={index}>
                    <Accordion
                      name={fileDetails.name}
                      content={fileDetails.content}
                    />
                  </React.Fragment>
                );
              } else {
                return (
                  <React.Fragment key={index}>
                    <div className="row">
                      <div className="row-title">
                        <div className="link">{fileDetails.name}</div>
                      </div>
                      <Link to={fileDetails.file} target="_blank" download>
                        <div className="row-text">
                          <Download />
                        </div>
                      </Link>
                    </div>
                  </React.Fragment>
                );
              }
            })}
          </div>

          <h1 className="title" id="asm">
            ASM
          </h1>
          <div id="containerReports">
            {ASMData.map((fileDetails, index) => {
              if (fileDetails.content) {
                return (
                  <React.Fragment key={index}>
                    <Accordion
                      name={fileDetails.name}
                      content={fileDetails.content}
                    />
                  </React.Fragment>
                );
              } else {
                return (
                  <React.Fragment key={index}>
                    <div className="row">
                      <div className="row-title">
                        <div className="link">{fileDetails.name}</div>
                      </div>
                      <Link to={fileDetails.file} target="_blank" download>
                        <div className="row-text">
                          <Download />
                        </div>
                      </Link>
                    </div>
                  </React.Fragment>
                );
              }
            })}
          </div>

          <h1 className="title" id="acgr">
            ACGR Scorecard
          </h1>
          <div id="containerReports">
            {ACGRData.map((fileDetails, index) => {
              return (
                <div className="row" key={index}>
                  <div className="row-title">
                    <div className="link">{fileDetails.name}</div>
                  </div>
                  <Link to={fileDetails.file} target="_blank" download>
                    <div className="row-text">
                      <Download />
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Footer
        args={{
          height,
          width,
          styles: {
            height: 50,
            width: width,
            position: "absolute",
            bottom: 0,
          },
        }}
      />
    </div>
  );
};

export default Reports;
